import { Component, Input, OnInit } from '@angular/core';
import { EnumerationModel } from '@bayclubs/court-booking-employee-api';
import { CourtEventStatus } from '../../../shared-models/court-booking/enumerations';

@Component({
    selector: 'app-court-event-status-pill',
    templateUrl: './court-event-status-pill.component.html',
    styleUrls: ['./court-event-status-pill.component.scss'],
    standalone: false
})
export class CourtEventStatusPillComponent implements OnInit {
    @Input() status: EnumerationModel;
    @Input() infoPanel = false;
    @Input() timelinePanel = false;
    constructor() { }

    ngOnInit(): void { }


    public get statusName() {
        switch (this.status.code) {
            case CourtEventStatus.cancelled.code:
                return CourtEventStatus.cancelled.name;
            case CourtEventStatus.checkedIn.code:
                return CourtEventStatus.checkedIn.name;
            case CourtEventStatus.confirmed.code:
                return CourtEventStatus.confirmed.name;
            case CourtEventStatus.noShow.code:
                return CourtEventStatus.noShow.name;
            case CourtEventStatus.temporary.code:
                return CourtEventStatus.temporary.name;
            default:
                return this.status.name;
        }
    }

    public get cssClassName() {
        if (this.timelinePanel) {
            return `badge badge-timeline-${this.status.code}`;
        }

        if (this.infoPanel) {
            return `badge badge-info-${this.status.code}`;
        } else {
            return `badge badge-${this.status.code}`;
        }
    }
}
